module.exports = __webpack_public_path__ + "static/media/Peoplecellphone.a7fba392.jpg";